import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { IoClose, IoEyeOff, IoEye } from "react-icons/io5";
import { MdEdit } from "react-icons/md";
import { LiaTrashRestoreAltSolid } from "react-icons/lia";
import { IoTrashBinOutline } from "react-icons/io5";
import { AiOutlineStop } from "react-icons/ai";
import { IoPersonAddOutline } from "react-icons/io5";
import {
  clearUserSystemAddress,
  getAllUsers,
  updateUser,
} from "../store/actions/user";
import { showToast } from "../utills/tools";
import Select from "react-select";
import { assignUsertordp, getAllRdps } from "../store/actions/rdp";
import { toast } from "react-toastify";

const UserManagementTab = ({
  userHeader,
  userProducts,
  loading,
  totalUsers,
  filterQuery,
  filterQueryChange,
}) => {
  const dispatch = useDispatch();
  const [currentPage, setCurrentPage] = useState(1);
  const [currentData, setCurrentData] = useState(null);
  const [isModalEdit, setIsModalEdit] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [isBillingModalOpen, setIsBillingModalOpen] = useState(false);
  const [billingUser, setBillingUser] = useState(null);
  const [selectedServerType, setSelectedServerType] = useState("");
  const [selectedPricing, setSelectedPricing] = useState("");
  const itemsPerPage = 10;
  const rowsPerPage = filterQuery.limit;
  const totalCount = totalUsers;
  const [value, setValue] = useState(null);
  const totalPages = Math.ceil(totalCount / rowsPerPage) || 1;
  const totalItems = userProducts.length;

  const indexOfLastRow = Math.min(currentPage * rowsPerPage, totalCount);
  const indexOfFirstRow = Math.max(0, indexOfLastRow - rowsPerPage);

  const [selectedProduct, setSelectedProduct] = useState(null);
  const [renewalDuration, setRenewalDuration] = useState("");

  const serverTypes = {
    Shared: {
      price: {
        Monthly: "$15",
        Quarterly: "$25",
        HalfYearly: "$40",
        Yearly: "$90",
      },
      config: {
        processor: "Intel i3 3.4GHz",
        ram: "6 GB DDR3",
        hardDisk: "750 GB HDD",
        bandwidth: "10 TB",
        location: "US",
      },
    },
    VPS: {
      price: {
        Monthly: "$25",
        Quarterly: "$45",
        HalfYearly: "$100",
        Yearly: "$250",
      },
      config: {
        processor: "Intel i5 3.8GHz",
        ram: "8 GB DDR3",
        hardDisk: "1 TB HDD",
        bandwidth: "12 TB",
        location: "USA",
      },
    },

    Dedicated: {
      price: {
        Monthly: "$45",
        Quarterly: "$85",
        HalfYearly: "$140",
        Yearly: "$450",
      },
      config: {
        processor: "Intel i5 4.0GHz",
        ram: "12 GB DDR3",
        hardDisk: "2 TB HDD",
        bandwidth: "20 TB",
        location: "Europe",
      },
    },

    Cloud: {
      price: {
        Monthly: "$15",
        Quarterly: "$25",
        HalfYearly: "$40",
        Yearly: "$90",
      },
      config: {
        processor: "Intel i3 3.4GHz",
        ram: "6 GB DDR3",
        hardDisk: "750 GB HDD",
        bandwidth: "10 TB",
        location: "US",
      },
    },
  };

  const handleConfirmBilling = () => {
    console.log("Renewing:", {
      user: selectedProduct,
      serverType: selectedServerType,
      duration: selectedPricing,
      price: serverTypes[selectedServerType]?.pricing[selectedPricing] || "N/A",
      config: serverTypes[selectedServerType]?.config || {},
    });

    setIsBillingModalOpen(false);
    setSelectedServerType("");
    setSelectedPricing("");
  };

  const handleOpenBillingModal = (product) => {
    setSelectedProduct(product);
    setIsBillingModalOpen(true);
    setRenewalDuration(""); // Reset duration on open
  };

  //redux logic
  const rdps = useSelector((state) => state.rdps);

  const handlePageChange = (page) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
      filterQueryChange({ ...filterQuery, page: page.toString() });
    }
  };

  const currentItems = userProducts;

  const toggleModalEdit = (user) => {
    setIsModalEdit(true);
    setCurrentData(user);
  };

  const toggleModalEditClose = () => {
    setIsModalEdit(false);
    setCurrentData(null);
  };
  const handleEditUser = (e) => {
    e.preventDefault();
    const targetValue = e.target;
    dispatch(
      updateUser({
        id: currentData._id,
        data: {
          username: targetValue.username.value,
          email: targetValue.email.value,
          password: targetValue.password.value,
          roleId: targetValue.roleId.value,
        },
      })
    );
    setIsModalEdit(false);
    setCurrentData(null);
    showToast("SUCCESS", "User updated successfully!", {
      onClose: () => {
        // handleFetchData();
      },
    });
  };
  const togglePasswordVisibility = () => setShowPassword(!showPassword);

  const handleCloseBillingModal = () => {
  setIsBillingModalOpen(false);
  setBillingUser(null);
  setSelectedProduct(null);
  setSelectedServerType(""); 
  setSelectedPricing("");    
};


  const handleNext = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
      filterQueryChange({ ...filterQuery, page: currentPage + 1 }); // Update filter query
    }
  };

  const handlePrev = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
      filterQueryChange({ ...filterQuery, page: currentPage - 1 }); // Update filter query
    }
  };

  const goToPage = (pageNumber) => {
    setCurrentPage(pageNumber);
    filterQueryChange({ ...filterQuery, page: pageNumber }); // Update filter query
  };

  const handleBlockUser = (id) => {
    dispatch(updateUser({ id: id, data: { status: 0 } }));
    // Show a success toast message
    showToast("SUCCESS", "Block user successfully!", {
      position: "top-right", // Use string instead of POSITION.TOP_RIGHT
      autoClose: 600,
      onClose: () => {
        // handleFetchData();
      },
    });
  };

  const handleUnblockUser = (id) => {
    dispatch(updateUser({ id: id, data: { status: 1 } }));
    showToast("SUCCESS", "Unblock user successfully!", {
      position: "top-right", // Use string instead of POSITION.TOP_RIGHT
      autoClose: 600,
      onClose: () => {
        // handleFetchData();
      },
    });
  };

  const handleClearUser = (id) => {
    dispatch(clearUserSystemAddress({ userId: id }));
    showToast("SUCCESS", "User Address Cleared successfully!", {
      position: "top-right",
      autoClose: 600,
    });
  };

  useEffect(() => {
    dispatch(getAllRdps());
  }, [dispatch]);

  // Open the modal
  const handleOpenModal = (value) => {
    setCurrentData(value);
    setIsModalOpen(true);
  };

  // Close the modal
  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  // Toggle checkbox selection
  const handleCheckboxChange = (e) => {
    const value = e.target.value;
    setSelectedOptions(
      (prevSelectedOptions) =>
        prevSelectedOptions.includes(value)
          ? prevSelectedOptions.filter((option) => option !== value) // Deselect if already selected
          : [...prevSelectedOptions, value] // Select the option
    );
  };

  // Assign selected options
  const handleAssign = () => {
    let rdpList = value.map((option) => option.value);
    dispatch(
      assignUsertordp({
        rdpList: rdpList,
        userId: currentData._id,
      })
    );
    setCurrentData(null);
    setSelectedOptions([]);
    setIsModalOpen(false);
    toast.success("RDP Assigned successfully!", {
      position: "top-right", // Use string instead of POSITION.TOP_RIGHT
      autoClose: 600,
    });
  };

  // console.log(rdps?.rdpsList);
  const result = rdps?.rdpsList.filter(
    (item2) =>
      !currentData?.assignedRdps.some((item1) => item1._id === item2._id)
  );
  const options =
    result &&
    result.map((rdp) => ({
      value: rdp._id,
      label: `${rdp.Name} - ${rdp?.pannelConf?.hostName}`,
    }));

  return (
    <div className="relative bg-card overflow-x-auto shadow-md sm:rounded-lg m-1">
      {loading ? (
        <div className="text-center text-gray-500">Loading...</div>
      ) : totalItems === 0 ? (
        <div className="text-center text-gray-500">No products found</div>
      ) : (
        <>
          <table className="w-full text-sm text-left rtl:text-right bg-card  text-gray-500 dark:text-gray-400">
            <thead className="text-xs text-text uppercase bg-cardG ">
              <tr>
                {/* <th scope="col" className="p-4">
                  <div className="flex items-center">
                    <input
                      id="checkbox-all-search"
                      type="checkbox"
                      className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 dark:focus:ring-offset-gray-800 focus:ring-1 dark:bg-gray-700 dark:border-gray-600"
                      aria-label="Select all products"
                    />
                  </div>
                </th> */}
                {userHeader.map((header, index) => (
                  <th key={index} scope="col" className="px-6 py-3">
                    {header.label || header.key}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {currentItems.length > 0 ? (
                currentItems.map((product, index) => (
                  <tr
                    key={index}
                    className="bg-card border-b  dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-600"
                  >
                    {/* <td className="w-4 p-4">
                      <div className="flex items-center">
                        <input
                          type="checkbox"
                          className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 dark:focus:ring-offset-gray-800 focus:ring-1 dark:bg-gray-700 dark:border-gray-600"
                          aria-label={`Select product ${product.name}`}
                        />
                      </div>
                    </td> */}
                    <th
                      scope="row"
                      className="px-6 py-2 font-medium  whitespace-nowrap "
                    >
                      {product.username}
                    </th>
                    <td className="px-6 py-2">{product.email}</td>
                    <td className="px-6 py-2">
                      <div className="flex flex-col ">
                        <p>{product.Host_name}</p>
                        <p>{product.MAC_Address}</p>
                        <p>{product.System_IP}</p>
                      </div>
                    </td>
                    <td className="px-6 py-4">
                      {product.assignedRdps.map((rdp, index) => (
                        <div key={index}>
                          <p>
                            {rdp.Name} - {rdp.hostName}
                          </p>
                        </div>
                      ))}
                    </td>
                    <td className="px-6 py-2">
                      {product.roleId === 0 ? (
                        "Admin"
                      ) : product.roleId === 1 ? (
                        "User"
                      ) : (
                        <button className="border border-gray-700 hover:bg-blue-500 hover:text-white rounded-md ">
                          Update KYC
                        </button>
                      )}
                    </td>
                    <td className="px-6 py-2">
                      {" "}
                      {product?.status === true ? "Active" : "InActive"}
                    </td>
                    <td className="px-6 py-6 gap-4 flex flex-row align-center justify-center">
                      <button
                        onClick={() => toggleModalEdit(product)}
                        title="Edit"
                        className="font-medium text-blue-600 border border-blue-600 px-2 rounded-lg hover:text-white hover:bg-blue-600"
                      >
                        <MdEdit className="text-lg" />
                      </button>

                      {currentData && isModalEdit && (
                        <div
                          id="crud-modal"
                          className="fixed inset-0 z-50 flex items-center justify-center overflow-y-auto overflow-x-hidden bg-gray-900 bg-opacity-10"
                        >
                          <div className="relative p-4 w-full max-w-md h-auto">
                            <div className="relative bg-white rounded-lg shadow dark:bg-gray-700">
                              <div className="flex items-center justify-between p-4 md:p-5 border-b rounded-t dark:border-gray-600">
                                <h3 className="text-lg font-semibold text-gray-900 dark:text-white">
                                  Edit User
                                </h3>
                                <button
                                  type="button"
                                  className="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 ms-auto inline-flex justify-center items-center dark:hover:bg-gray-600 dark:hover:text-white"
                                  onClick={toggleModalEditClose}
                                >
                                  <IoClose className="w-5 h-5" />
                                </button>
                              </div>

                              <form
                                className="p-4 md:p-5"
                                onSubmit={handleEditUser}
                              >
                                <div className="grid gap-4 mb-4 grid-cols-2">
                                  <div className="col-span-2">
                                    <label
                                      htmlFor="username"
                                      className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                                    >
                                      Username
                                    </label>
                                    <input
                                      type="text"
                                      id="username"
                                      name="username"
                                      className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 dark:bg-gray-600 dark:border-gray-500 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500"
                                      placeholder="Enter your name"
                                      defaultValue={currentData.username}
                                      required
                                    />
                                  </div>

                                  <div className="col-span-2">
                                    <label
                                      htmlFor="email"
                                      className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                                    >
                                      Email
                                    </label>
                                    <input
                                      type="email"
                                      id="email"
                                      name="email"
                                      className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 dark:bg-gray-600 dark:border-gray-500 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500"
                                      placeholder="Enter your email"
                                      defaultValue={currentData.email}
                                      required
                                    />
                                  </div>
                                  <div className="col-span-2 relative">
                                    <label
                                      htmlFor="password"
                                      className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                                    >
                                      Password
                                    </label>
                                    <input
                                      type={showPassword ? "text" : "password"}
                                      id="password"
                                      name="password"
                                      className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 dark:bg-gray-600 dark:border-gray-500 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500"
                                      placeholder="Enter your password"
                                      defaultValue={currentData.user_password}
                                      required
                                    />
                                    <button
                                      type="button"
                                      onClick={togglePasswordVisibility}
                                      className="absolute right-2 top-10 text-gray-600 dark:text-gray-300"
                                    >
                                      {showPassword ? <IoEyeOff /> : <IoEye />}
                                    </button>
                                  </div>

                                  {/* Role Dropdown */}
                                  <div className="col-span-2">
                                    <label
                                      htmlFor="roleId"
                                      className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                                    >
                                      Role
                                    </label>
                                    <select
                                      id="roleId"
                                      name="roleId"
                                      className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 dark:bg-gray-600 dark:border-gray-500 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500"
                                      defaultValue={currentData.roleId}
                                    >
                                      <option value="0">Admin</option>
                                      <option value="1">User</option>
                                    </select>
                                  </div>
                                </div>

                                <button
                                  type="submit"
                                  className="text-white w-full justify-center inline-flex items-center bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
                                >
                                  Edit
                                </button>
                              </form>
                            </div>
                          </div>
                        </div>
                      )}

                      {product?.status === 1 && (
                        <button
                          className="font-medium text-red-600  border  border-red-600  px-2 rounded-lg hover:text-white hover:bg-red-600"
                          onClick={() => handleBlockUser(product?._id)}
                        >
                          <IoTrashBinOutline className="text-lg" />
                        </button>
                      )}
                      {product?.status === 0 && (
                        <button
                          onClick={() => handleUnblockUser(product?._id)}
                          className="font-medium text-green-600  border  border-green-600  px-2 rounded-lg hover:text-white hover:bg-green-600"
                        >
                          <LiaTrashRestoreAltSolid className="text-lg" />
                        </button>
                      )}
                      <button
                        onClick={() => handleClearUser(product?._id)}
                        title="Suspend"
                        className="font-medium text-red-600  border border-red-600  px-2 py-1 rounded-lg hover:text-white hover:bg-red-600"
                      >
                        <AiOutlineStop />
                      </button>
                      <button
                        onClick={() => handleOpenModal(product)}
                        title="assign"
                        className="font-medium text-blue-600 border border-blue-600 px-2 py-1 rounded-lg hover:text-white hover:bg-blue-600"
                      >
                        <IoPersonAddOutline className="text-lg" />
                      </button>
                      <button
                        onClick={() => handleOpenBillingModal(product)}
                        title="Billing"
                        className="font-medium text-purple-600 border border-purple-600 px-2 py-1 rounded-lg hover:text-white hover:bg-purple-600"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          className="h-4 w-4"
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke="currentColor"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M9 14l2-2 4 4m0 0l2-2m-6 6H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v4"
                          />
                        </svg>
                      </button>

                      {/* {Billing Model } */}

                      {/* Billing Modal */}
                      {isBillingModalOpen && selectedProduct && (
                        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-30">
                          <div className="bg-white rounded-lg shadow-lg p-6 w-[400px]">
                            <div className="flex justify-between items-center mb-4">
                              <h2 className="text-lg font-semibold text-gray-800">
                                Renew Server Subscription
                              </h2>
                              <button onClick={handleCloseBillingModal}>
                                <IoClose className="text-xl text-gray-600 hover:text-red-600" />
                              </button>
                            </div>

                            <div className="mb-4">
                              <label className="block text-sm font-medium mb-1">
                                Server Type
                              </label>
                              <select
                                value={selectedServerType}
                                onChange={(e) => {
                                  setSelectedServerType(e.target.value);
                                  setSelectedPricing(""); // Reset pricing on change
                                }}
                                className="w-full border border-gray-300 rounded px-3 py-2"
                              >
                                <option value="">Select Server Type</option>
                                {Object.keys(serverTypes).map((type) => (
                                  <option key={type} value={type}>
                                    {type}
                                  </option>
                                ))}
                              </select>
                            </div>

                            {selectedServerType && (
                              <div className="mb-4">
                                <label className="block text-sm font-medium mb-1">
                                  Duration
                                </label>
                                <select
                                  value={selectedPricing}
                                  onChange={(e) =>
                                    setSelectedPricing(e.target.value)
                                  }
                                  className="w-full border border-gray-300 rounded px-3 py-2"
                                >
                                  <option value="">Pricing</option>
                                  {Object.keys(
                                    serverTypes[selectedServerType].price
                                  ).map((duration) => (
                                    <option key={duration} value={duration}>
                                      {duration}
                                    </option>
                                  ))}
                                </select>
                              </div>
                            )}

                            {/* Show price and config summary */}
                            {/* Show price and config summary */}
                            {selectedServerType && (
                              <div className="mb-4 text-sm text-gray-700 space-y-1">
                                {selectedPricing && (
                                  <p>
                                    <strong>Price:</strong>{" "}
                                    {
                                      serverTypes[selectedServerType].price[
                                        selectedPricing
                                      ]
                                    }
                                  </p>
                                )}
                                {Object.entries(
                                  serverTypes[selectedServerType]?.config
                                ).map(([key, value]) => (
                                  <p key={key}>
                                    <strong>{key}:</strong> {value}
                                  </p>
                                ))}
                              </div>
                            )}

                            <div className="flex justify-end gap-3">
                              <button
                                onClick={handleCloseBillingModal}
                                className="bg-gray-300 hover:bg-gray-400 text-sm px-4 py-2 rounded"
                              >
                                Cancel
                              </button>
                              <button
                                onClick={handleConfirmBilling}
                                className="bg-purple-600 hover:bg-purple-700 text-white text-sm px-4 py-2 rounded"
                                disabled={
                                  !selectedServerType || !selectedPricing
                                }
                              >
                                Confirm
                              </button>
                            </div>
                          </div>
                        </div>
                      )}

                      {/* Config Info Display */}
                      {selectedServerType && selectedPricing && (
                        <div className="mb-4 text-sm text-gray-700 space-y-1">
                          <p>
                            <strong>Price:</strong>{" "}
                            {
                              serverTypes[selectedServerType].price[
                                selectedPricing
                              ]
                            }
                          </p>
                          {Object.entries(
                            serverTypes[selectedServerType].config
                          ).map(([key, value]) => (
                            <p key={key}>
                              <strong>{key}:</strong> {value}
                            </p>
                          ))}
                        </div>
                      )}
                      {/* Modal */}
                      {isModalOpen && (
                        <div className="fixed inset-0 z-50 flex items-center justify-center overflow-y-auto overflow-x-hidden bg-gray-900 bg-opacity-10">
                          <div className="bg-card p-4 rounded-lg shadow-lg w-96">
                            {/* Modal Header */}
                            <div className="flex items-center justify-between p-0 border-b my-2  rounded-t dark:border-gray-600">
                              <h3 className="text-lg font-medium text-text">
                                Choose Rdps from the list
                              </h3>
                              <button
                                type="button"
                                className="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 ms-auto inline-flex justify-center items-center dark:hover:bg-gray-600 dark:hover:text-white"
                                onClick={handleCloseModal}
                              >
                                <IoClose className="w-5 h-5" />
                              </button>
                            </div>

                            {/* Modal Body */}
                            <Select
                              options={options}
                              defaultValue={value}
                              placeholder="Select an rdps"
                              onChange={setValue}
                              isMulti
                            />

                            {/* Modal Footer with buttons */}
                            <div className="flex justify-between mt-4">
                              <button
                                onClick={handleCloseModal}
                                className="px-4 py-1 bg-gray-300 rounded-md"
                              >
                                Close
                              </button>
                              <button
                                onClick={handleAssign}
                                className="px-4 py-1 bg-blue-600 text-white rounded-md"
                              >
                                Assign
                              </button>
                            </div>
                          </div>
                        </div>
                      )}
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="7" className="text-center py-4">
                    No Users Found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
          <nav
            className="flex items-center justify-between p-2"
            aria-label="Table navigation"
          >
            <span className="text-sm font-normal text-black dark:text-gray-400">
              Showing{" "}
              <span className="font-semibold text-text">
                {" "}
                {indexOfFirstRow + 1}-{Math.min(indexOfLastRow, totalCount)}
              </span>{" "}
              of <span className="font-semibold text-text"> {totalCount}</span>
            </span>

            <ul className="inline-flex -space-x-px text-sm h-8">
              {/* Previous Button */}
              <li>
                <button
                  onClick={() => handlePageChange(currentPage - 1)}
                  disabled={currentPage === 1}
                  className="flex items-center justify-center px-3 h-8 text-gray-500 bg-white border border-gray-300 rounded-l-lg hover:bg-gray-100 dark:bg-gray-800 dark:border-gray-700 dark:text-gray-400 dark:hover:bg-gray-700"
                  aria-disabled={currentPage === 1}
                >
                  Previous
                </button>
              </li>

              {/* First Page */}
              <li>
                <button
                  onClick={() => handlePageChange(1)}
                  className={`flex items-center justify-center px-3 h-8 ${
                    currentPage === 1
                      ? "text-white bg-blue-500"
                      : "text-gray-500 bg-white"
                  } border border-gray-300 hover:bg-gray-100 dark:bg-gray-800 dark:border-gray-700 dark:text-gray-400 dark:hover:bg-gray-700`}
                >
                  1
                </button>
              </li>

              {/* Second Page */}
              {/* Second Page */}
              {totalPages > 2 && (
                <li>
                  <button
                    onClick={() => handlePageChange(2)}
                    className={`flex items-center justify-center px-3 h-8 ${
                      currentPage === 2
                        ? "text-white bg-blue-500"
                        : "text-gray-500 bg-white"
                    } border border-gray-300 hover:bg-gray-100 dark:bg-gray-800 dark:border-gray-700 dark:text-gray-400 dark:hover:bg-gray-700`}
                  >
                    2
                  </button>
                </li>
              )}

              {/* Ellipsis for skipped pages */}
              {currentPage > 3 && <span className="px-2">...</span>}

              {/* Last two pages */}
              {currentPage < totalPages - 2 && (
                <span className="px-2">...</span>
              )}
              {totalPages > 2 && (
                <li>
                  <button
                    onClick={() => handlePageChange(totalPages - 1)}
                    className={`flex items-center justify-center px-3 h-8 ${
                      currentPage === totalPages - 1
                        ? "text-white bg-blue-500"
                        : "text-gray-500 bg-white"
                    } border border-gray-300 hover:bg-gray-100 dark:bg-gray-800 dark:border-gray-700 dark:text-gray-400 dark:hover:bg-gray-700`}
                  >
                    {totalPages - 1}
                  </button>
                </li>
              )}
              {totalPages > 1 && (
                <li>
                  <button
                    onClick={() => handlePageChange(totalPages)}
                    className={`flex items-center justify-center px-3 h-8 ${
                      currentPage === totalPages
                        ? "text-white bg-blue-500"
                        : "text-gray-500 bg-white"
                    } border border-gray-300 hover:bg-gray-100 dark:bg-gray-800 dark:border-gray-700 dark:text-gray-400 dark:hover:bg-gray-700`}
                  >
                    {totalPages}
                  </button>
                </li>
              )}

              {/* Next Button */}
              <li>
                <button
                  onClick={() => handlePageChange(currentPage + 1)}
                  disabled={currentPage === totalPages}
                  className="flex items-center justify-center px-3 h-8 text-gray-500 bg-white border border-gray-300 rounded-r-lg hover:bg-gray-100 dark:bg-gray-800 dark:border-gray-700 dark:text-gray-400 dark:hover:bg-gray-700"
                  aria-disabled={currentPage === totalPages}
                >
                  Next
                </button>
              </li>
            </ul>
          </nav>
        </>
      )}
    </div>
  );
};

export default UserManagementTab;
